import { render, staticRenderFns } from "./TableExpandData.vue?vue&type=template&id=1040f04e&scoped=true"
import script from "./TableExpandData.vue?vue&type=script&lang=js"
export * from "./TableExpandData.vue?vue&type=script&lang=js"
import style0 from "./TableExpandData.vue?vue&type=style&index=0&id=1040f04e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1040f04e",
  null
  
)

export default component.exports